import React from "react";
import { useForm } from "react-hook-form";
import DateRangePicker from "./DateRangePicker";

const FilterPanel = ({ dateRange, viewMode, limit, sortBy, onFieldChange }) => {
    const { register, handleSubmit, watch } = useForm({
        defaultValues: {
            sortBy,
            viewMode,
            limit,
        },
    });

    const onSubmit = (data) => {
        onFieldChange("sortBy", data.sortBy);
        onFieldChange("viewMode", data.viewMode);
        onFieldChange("limit", Number(data.limit));
    };

    return (
        <form
            onChange={handleSubmit(onSubmit)}
            className="flex gap-6 p-4 rounded bg-[#2D2D30] border border-[#3E3E42] mb-4"
        >
            {/* Период анализа */}
            <div>
                <label className="block text-sm text-gray-400">
                    Период анализа
                </label>
                <DateRangePicker
                    startDate={dateRange.start}
                    endDate={dateRange.end}
                    onChange={(range) => onFieldChange("dateRange", range)}
                />
            </div>

            {/* Настройки отображения */}
            <div>
                <label className="block text-sm text-gray-400">
                    Настройки сортировки
                </label>
                <div className="flex gap-2">
                    {/* Сортировка */}
                    <select
                        {...register("sortBy")}
                        className="w-full p-2 rounded bg-[#1E1E1E] border border-[#3E3E42] text-white focus:outline-none focus:border-[#007ACC] mt-2"
                    >
                        <option value="delayCount">Опоздания</option>
                        <option value="overtimeCount">Переработки</option>
                        <option value="earlyExitCount">Ранние уходы</option>
                        <option value="missedCount">Пропуски</option>
                        <option value="totalViolations">
                            Общее количество нарушений
                        </option>
                    </select>

                    {/* Режим просмотра */}
                    <select
                        {...register("viewMode")}
                        className="w-full p-2 rounded bg-[#1E1E1E] border border-[#3E3E42] text-white focus:outline-none focus:border-[#007ACC] mt-2"
                    >
                        <option value="top">Топ</option>
                        <option value="bottom">Анти-топ</option>
                        <option value="all">Все</option>
                    </select>

                    {/* Лимит записей */}
                    <input
                        type="number"
                        {...register("limit", { min: 1, max: 100 })}
                        className="w-full p-2 rounded bg-[#1E1E1E] border border-[#3E3E42] text-white focus:outline-none focus:border-[#007ACC] mt-2"
                        placeholder="Лимит записей"
                    />
                </div>
            </div>
        </form>
    );
};

export default FilterPanel;
